import { useNavigate } from 'react-router-dom'

import { PureTable } from '../../../../../common/ui/pure-table/pure-table'
import { MilestoneItem } from '../../../../../entities/workflow/types/workflow.types'
import { getMilestoneTableColumns } from '../../helpers/get-milestone-table-columns'

type MilestoneTableProps = {
  milestones: MilestoneItem[]
}

export const MilestoneTable = ({ milestones }: MilestoneTableProps) => {
  const navigate = useNavigate()
  const columns = getMilestoneTableColumns(navigate)

  return (
    <PureTable
      columns={columns}
      dataSource={milestones}
      rowKey="id"
    />
  )
}
